import React from "react";

const Repairs = ({ image , loaction }) => {
  return (
    <div className={`absolute ${loaction}`}>
      <div className="bg-white rounded-full w-[140px] h-[140px] max-lg:w-[70px] max-lg:h-[70px] flex items-center p-4" style={{boxShadow: "0px 2px 10px 6px #c3c3c326"}}>
        <img src={image} className="mx-auto max-lg:w-[40px]" width="70px" />
      </div>
    </div>
  );
};

export default Repairs;
